/*@ngInject*/
const UIIsTooltipEnabledDirective = function ($window, $timeout) {

    let linkFunction = function ($scope, $elm) {

        let window = $($window),
            timerDelay = 1000,
            timeoutList = [];

            function getColumnOverflow() {
                let $element = $($elm),
                    $clone = $element
                        .clone()
                        .css({display: 'inline', width: 'auto', visibility: 'hidden'})
                        .appendTo('body');

                if ($scope.uiIsTooltipEnabledCheckParentWidth) {
                    $scope.uiIsTooltipEnabled = $clone.width() > $element.parent().width();
                } else {
                    $scope.uiIsTooltipEnabled = $clone.width() > $element.width();
                }

                if ($scope.uiIsTooltipEnabledCheckParentHeight) {
                    $scope.uiIsTooltipEnabled = $element.parent().height() < ($element.height() - 10);
                }

                $clone.remove();
            }

            window.on('resize.uiIsTooltipEnabled', getColumnOverflow);

            $scope.$on('$destroy', function () {
                window.off('resize.uiIsTooltipEnabled', getColumnOverflow);
                _.each(timeoutList, function (item) {
                    $timeout.cancel(item);
                });
            });

            timeoutList.push($timeout(function () {
                getColumnOverflow();
            }, timerDelay));
        };

    return {
        restrict: 'A',
        link: linkFunction,
        scope: {
            'uiIsTooltipEnabled': '=',
            'uiIsTooltipEnabledCheckParentWidth': '<',
            'uiIsTooltipEnabledCheckParentHeight':'<'
        }
    };
};

angular.module('umCore')
    .directive('uiIsTooltipEnabled', UIIsTooltipEnabledDirective);
